function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var CallSettingTemplate = require('./call-setting.template');
var SaitoOverlay = require('../../../../lib/saito/ui/saito-overlay/saito-overlay.js');

/**
 *
 * This is the part of the splash screen where you can check your camera
 * and mute your self before creating or joining a meeting
 *
 * There are (currently disabled) functions to test your mic by recording a brief message
 */
var CallSetting = /*#__PURE__*/function () {
  function CallSetting(app, mod) {
    _classCallCheck(this, CallSetting);
    this.app = app;
    this.mod = mod;
    this.overlay = new SaitoOverlay(app, mod);
    this.videoStream = null;
    this.audioStream = null;
    this.videoEnabled = true;
    this.audioEnabled = true;
    this.isRecording = false;
    this.recordedChunks = [];
    this.mediaRecorder;
    this.recordedAudio = null;
    this.isPlaying = false;
  }
  return _createClass(CallSetting, [{
    key: "render",
    value: function render() {
      var _this = this;
      this.overlay.show(CallSettingTemplate(this), function () {
        _this.remove();
      });
      var previewWindow = document.getElementById('preview-video');
      if (previewWindow) {
        this.getUserMedia(previewWindow);
      }
    }
  }, {
    key: "remove",
    value: function remove() {
      if (this.audioStream) {
        this.audioStream.getTracks().forEach(function (track) {
          track.stop();
        });
      }
      if (this.videoStream) {
        this.videoStream.getTracks().forEach(function (track) {
          track.stop();
        });
      }
    }
  }, {
    key: "attachEvents",
    value: function attachEvents(videoElement) {
      var _this2 = this;
      var toggleVideoButton = document.getElementById('toggle-video');
      var toggleAudioButton = document.getElementById('toggle-audio');
      this.videoInput = document.getElementById('video-input');
      this.audioInput = document.getElementById('audio-input');
      var testMicButton = document.getElementById('test-mic');
      var audioProgress = document.getElementById('audio-progress');
      var togglePlayback = document.getElementById('toggle-playback');
      if (testMicButton) {
        testMicButton.addEventListener('click', function () {
          return _this2.testMicrophone(testMicButton, audioProgress);
        });
      }
      if (toggleVideoButton) {
        toggleVideoButton.addEventListener('click', function () {
          if (!_this2.videoStream) return;
          if (_this2.videoEnabled) {
            _this2.videoStream.getVideoTracks()[0].enabled = false;
            toggleVideoButton.classList.remove('fa-video');
            toggleVideoButton.classList.add('fa-video-slash');
          } else {
            _this2.videoStream.getVideoTracks()[0].enabled = true;
            toggleVideoButton.classList.remove('fa-video-slash');
            toggleVideoButton.classList.add('fa-video');
          }
          _this2.videoEnabled = !_this2.videoEnabled;
          var notification = _this2.videoEnabled ? 'Video enabled' : 'Video disabled';
          siteMessage(notification, 3000);
        });
      }
      if (toggleAudioButton) {
        toggleAudioButton.addEventListener('click', function () {
          if (_this2.audioEnabled) {
            _this2.audioStream.getAudioTracks()[0].enabled = false;
            toggleAudioButton.classList.remove('fa-microphone');
            toggleAudioButton.classList.add('fa-microphone-slash');
          } else {
            _this2.audioStream.getAudioTracks()[0].enabled = true;
            toggleAudioButton.classList.remove('fa-microphone-slash');
            toggleAudioButton.classList.add('fa-microphone');
          }
          _this2.audioEnabled = !_this2.audioEnabled;
          var notification = _this2.audioEnabled ? 'Audio enabled' : 'Audio disabled';
          siteMessage(notification, 3000);
        });
      }
      if (this.videoInput) {
        this.videoInput.addEventListener('change', function () {
          _this2.updateMedia('video', videoElement);
          _this2.app.options.stun.settings["preferred_video"] = _this2.videoInput.value;
          _this2.app.storage.saveOptions();
        });
      }
      if (this.audioInput) {
        this.audioInput.addEventListener('change', function () {
          _this2.updateMedia('audio', videoElement);
          _this2.app.options.stun.settings["preferred_audio"] = _this2.audioInput.value;
          _this2.app.storage.saveOptions();
        });
      }
      if (togglePlayback) {
        togglePlayback.addEventListener('click', function () {
          var iconElement = document.getElementById('toggle-playback');
          if (iconElement.classList.contains('fa-play')) {
            iconElement.classList.remove('fa-play');
            iconElement.classList.add('fa-pause');
            if (_this2.recordedAudio) {
              _this2.recordedAudio.play();
              _this2.updateAudioProgress(audioProgress);
            }
          } else {
            iconElement.classList.remove('fa-pause');
            iconElement.classList.add('fa-play');
            if (_this2.recordedAudio) {
              _this2.recordedAudio.pause();
            }
          }
        });
      }
    }
  }, {
    key: "getUserMedia",
    value: function () {
      var _getUserMedia = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(videoElement) {
        var _this$app$options$stu, _this$app$options$stu2;
        var audioConstraints, videoConstraints, _t, _t2;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              // check saved preferences...
              audioConstraints = {
                audio: true
              };
              videoConstraints = {
                video: {
                  width: {
                    min: 640,
                    max: 1280
                  },
                  height: {
                    min: 400,
                    max: 720
                  },
                  aspectRatio: {
                    ideal: 1.333333
                  }
                }
              };
              if ((_this$app$options$stu = this.app.options.stun) !== null && _this$app$options$stu !== void 0 && (_this$app$options$stu = _this$app$options$stu.settings) !== null && _this$app$options$stu !== void 0 && _this$app$options$stu.preferred_audio) {
                audioConstraints.audio['deviceId'] = this.app.options.stun.settings.preferred_audio;
              }
              if ((_this$app$options$stu2 = this.app.options.stun) !== null && _this$app$options$stu2 !== void 0 && (_this$app$options$stu2 = _this$app$options$stu2.settings) !== null && _this$app$options$stu2 !== void 0 && _this$app$options$stu2.preferred_video) {
                videoConstraints.video['deviceId'] = this.app.options.stun.settings.preferred_video;
              }
              _context.p = 1;
              _context.n = 2;
              return navigator.mediaDevices.getUserMedia(audioConstraints);
            case 2:
              this.audioStream = _context.v;
              this.audioEnabled = true;
              _context.n = 4;
              break;
            case 3:
              _context.p = 3;
              _t = _context.v;
              console.error('TALK.callSetting: Error accessing media devices.', _t);
              salert('Error access media devices, please check your permissions');
            case 4:
              _context.p = 4;
              _context.n = 5;
              return navigator.mediaDevices.getUserMedia(videoConstraints);
            case 5:
              this.videoStream = _context.v;
              videoElement.srcObject = this.videoStream;
              this.videoEnabled = true;
              _context.n = 7;
              break;
            case 6:
              _context.p = 6;
              _t2 = _context.v;
              console.error('TALK.callSetting: Error accessing media devices.', _t2);
              this.videoStream = null;
              this.videoEnabled = false;
              salert('Error access camera, using audio only mode ');
            case 7:
              this.attachEvents();
              return _context.a(2, this.loadMediaDevices());
          }
        }, _callee, this, [[4, 6], [1, 3]]);
      }));
      function getUserMedia(_x) {
        return _getUserMedia.apply(this, arguments);
      }
      return getUserMedia;
    }()
  }, {
    key: "loadMediaDevices",
    value: function () {
      var _loadMediaDevices = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var _this3 = this;
        var devices, videoCt, audioCt;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return navigator.mediaDevices.enumerateDevices();
            case 1:
              devices = _context2.v;
              videoCt = 0;
              audioCt = 0;
              devices.forEach(function (device) {
                var option = document.createElement('option');
                option.value = device.deviceId;
                option.textContent = device.label || "".concat(device.kind, " - ").concat(device.deviceId);
                if (device.kind === 'videoinput' && _this3.videoInput) {
                  var _this3$app$options$st;
                  if (device.deviceId === ((_this3$app$options$st = _this3.app.options.stun) === null || _this3$app$options$st === void 0 || (_this3$app$options$st = _this3$app$options$st.settings) === null || _this3$app$options$st === void 0 ? void 0 : _this3$app$options$st.preferred_video)) {
                    option.selected = true;
                  }
                  videoCt++;
                  _this3.videoInput.appendChild(option);
                } else if (device.kind === 'audioinput' && _this3.audioInput) {
                  var _this3$app$options$st2;
                  if (device.deviceId === ((_this3$app$options$st2 = _this3.app.options.stun) === null || _this3$app$options$st2 === void 0 || (_this3$app$options$st2 = _this3$app$options$st2.settings) === null || _this3$app$options$st2 === void 0 ? void 0 : _this3$app$options$st2.preferred_audio)) {
                    option.selected = true;
                  }
                  audioCt++;
                  _this3.audioInput.appendChild(option);
                }
              });
              if (videoCt > 1) {
                this.videoInput.style.display = 'flex';
                document.querySelector('.stun-input-settings legend').style.display = 'block';
              }
              if (audioCt > 1) {
                this.audioInput.style.display = 'flex';
                document.querySelector('.stun-input-settings legend').style.display = 'block';
              }
            case 2:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function loadMediaDevices() {
        return _loadMediaDevices.apply(this, arguments);
      }
      return loadMediaDevices;
    }()
  }, {
    key: "updateMedia",
    value: function () {
      var _updateMedia = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(kind, videoElement) {
        var constraints, stream;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              constraints = kind === 'video' ? {
                video: {
                  deviceId: this.videoInput.value
                }
              } : {
                audio: {
                  deviceId: this.audioInput.value
                }
              };
              _context3.n = 1;
              return navigator.mediaDevices.getUserMedia(constraints);
            case 1:
              stream = _context3.v;
              if (!(kind === 'video')) {
                _context3.n = 3;
                break;
              }
              if (this.videoStream) {
                _context3.n = 2;
                break;
              }
              return _context3.a(2);
            case 2:
              this.videoStream.getVideoTracks()[0].stop();
              this.videoStream = stream;
              videoElement.srcObject = this.videoStream;
              _context3.n = 4;
              break;
            case 3:
              this.audioStream.getAudioTracks()[0].stop();
              this.audioStream = stream;
            case 4:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function updateMedia(_x2, _x3) {
        return _updateMedia.apply(this, arguments);
      }
      return updateMedia;
    }()
  }, {
    key: "testMicrophone",
    value: function testMicrophone(testMicButton, audioProgress) {
      var _this4 = this;
      if (!this.isRecording) {
        this.isRecording = true;
        testMicButton.textContent = 'Stop Test';
        this.recordedChunks = [];
        var options = {
          mimeType: 'audio/webm'
        };
        this.mediaRecorder = new MediaRecorder(this.audioStream, options);
        this.mediaRecorder.ondataavailable = function (event) {
          if (event.data.size > 0) {
            _this4.recordedChunks.push(event.data);
          }
        };
        this.mediaRecorder.onstop = function () {
          var blob = new Blob(_this4.recordedChunks, {
            type: 'audio/webm'
          });
          var audioURL = URL.createObjectURL(blob);
          _this4.recordedAudio = new Audio(audioURL);
          _this4.updateAudioProgress(audioProgress);
        };
        this.mediaRecorder.start();
      } else {
        this.isRecording = false;
        testMicButton.textContent = 'Test Microphone';
        this.mediaRecorder.stop();
      }
    }
  }, {
    key: "updateAudioProgress",
    value: function updateAudioProgress(audioProgress) {
      var _this5 = this;
      if (this.recordedAudio) {
        this.recordedAudio.addEventListener('loadedmetadata', function () {
          _this5.recordedAudio.ontimeupdate = function () {
            var currentTime = _this5.formatTime(_this5.recordedAudio.currentTime);
            var duration = isNaN(_this5.recordedAudio.duration) || _this5.recordedAudio.duration === Infinity ? 'Loading...' : _this5.formatTime(_this5.recordedAudio.duration);
            audioProgress.textContent = "".concat(currentTime, " / ").concat(duration);

            // Update progress bar
            var progressBar = document.getElementById('progress');
            var progressPercentage = _this5.recordedAudio.currentTime / _this5.recordedAudio.duration * 100;
            progressBar.style.width = "".concat(progressPercentage, "%");
          };
        });
      }
    }
  }, {
    key: "formatTime",
    value: function formatTime(time) {
      var minutes = Math.floor(time / 60);
      var seconds = Math.floor(time % 60);
      return "".concat(minutes.toString().padStart(2, '0'), ":").concat(seconds.toString().padStart(2, '0'));
    }
  }, {
    key: "returnSettings",
    value: function returnSettings() {
      var _this$app$options$stu3, _this$app$options$stu4;
      //Use defaults if unopened...
      var ui = 'large'; //this.mod.browser_active ? 'large' : 'video';

      // True / from options
      var video = ((_this$app$options$stu3 = this.app.options.stun) === null || _this$app$options$stu3 === void 0 || (_this$app$options$stu3 = _this$app$options$stu3.settings) === null || _this$app$options$stu3 === void 0 ? void 0 : _this$app$options$stu3.preferred_video) || true;
      var audio = ((_this$app$options$stu4 = this.app.options.stun) === null || _this$app$options$stu4 === void 0 || (_this$app$options$stu4 = _this$app$options$stu4.settings) === null || _this$app$options$stu4 === void 0 ? void 0 : _this$app$options$stu4.preferred_audio) || true;

      // Read from DOM
      if (this.videoInput) {
        video = {
          deviceId: this.videoInput.value
        };
        audio = {
          deviceId: this.audioInput.value
        };
      }

      // User disabled
      if (!this.videoEnabled) {
        video = false;
      }
      if (!this.audioEnabled) {
        audio = false;
      }
      return {
        ui: ui,
        video: video,
        audio: audio
      };
    }
  }]);
}();
module.exports = CallSetting;